module.exports = __webpack_public_path__ + "static/army-of-seeds-0db036b896d7b25806f6a39bb25a704c.jpg";